import NwImg from './NwImg.vue';

const install = function (Vue) {
  Vue.mixin({
    components: {
      'NwImg': NwImg
    }
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install: install
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/nw-img-vue/index.js
// module id = qjii
// module chunks = 1